module.exports = __webpack_public_path__ + "6deda05783407e2bc749c7d3b396ae23.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2000_35_teaser_image.jpg
// module id = 547
// module chunks = 0